import {lazy, FC, Suspense} from 'react'
import {Route, Routes, Navigate} from 'react-router-dom'
import {MasterLayout} from '../../_metronic/layout/MasterLayout'
import {PageTitle} from '../../_metronic/layout/core'
import TopBarProgress from 'react-topbar-progress-indicator'
import {getCSSVariableValue} from '../../_metronic/assets/ts/_utils'
import {WithChildren} from '../../_metronic/helpers'
import UserAddPage from '../modules/apps/management/users-list/UserAddPage'
import UserDetails from '../modules/apps/management/users-list/user-details/UserDetails'
import {BlockListWrapper} from '../modules/apps/management/block-unblock-user/BlockUserList'
import {JobListWrapper} from '../modules/apps/management/job-list/JobList'
import JobAddPage from '../modules/apps/management/job-list/JobAddPage'
// import NotificationsAddPage from '../modules/apps/management/notifications/NotificationsAddPage'

const PrivateRoutes = () => {
  const UsersListWrapper = lazy(() =>
    import('../modules/apps/management/users-list/UsersList').then((m) => ({
      default: m.UsersListWrapper,
    }))
  )

  const DeletedUsersListWrapper = lazy(() =>
    import('../modules/apps/management/deleted-users/DeletedUsersList').then((m) => ({
      default: m.DeletedUsersListWrapper,
    }))
  )

  const EventsListWrapper = lazy(() =>
    import('../modules/apps/management/events-list/EventsList').then((m) => ({
      default: m.EventsListWrapper,
    }))
  )

  const EventDetails = lazy(() =>
    import('../modules/apps/management/events-list/EventDetails').then((m) => ({
      default: m.default,
    }))
  )

  const EventAddPage = lazy(() =>
    import('../modules/apps/management/events-list/EventAddPage').then((m) => ({
      default: m.default,
    }))
  )

  const EventCategoriesListWrapper = lazy(() =>
    import('../modules/apps/management/event-categories-list/EventCategoriesList').then((m) => ({
      default: m.EventCategoriesListWrapper,
    }))
  )

  const EventCategoryAddPage = lazy(() =>
    import('../modules/apps/management/event-categories-list/EventCategoryAddPage').then((m) => ({
      default: m.default,
    }))
  )

  const DirectoryListWrapper = lazy(() =>
    import('../modules/apps/management/directory-list/DirectoryList').then((m) => ({
      default: m.DirectoryListWrapper,
    }))
  )

  const RolesListWrapper = lazy(() =>
    import('../modules/apps/management/roles/RolesList').then((m) => ({
      default: m.RolesListWrapper,
    }))
  )

  const RoleAddPage = lazy(() => import('../modules/apps/management/roles/RoleAddPage'))
  const RoleEditPage = lazy(() => import('../modules/apps/management/roles/RoleEditPage'))
  const RoleViewPage = lazy(() => import('../modules/apps/management/roles/RoleViewPage'))

  const PermissionListWrapper = lazy(() =>
    import('../modules/apps/management/permission/PermissionList').then((m) => ({
      default: m.PermissionListWrapper,
    }))
  )

  // const PermissionAddPage = lazy(() =>
  //   import('../modules/apps/management/permission/PermissionAddPage')
  // )
  const PermissionEditPage = lazy(() =>
    import('../modules/apps/management/permission/PermissionEditPage')
  )
  // const PermissionViewPage = lazy(() =>
  //   import('../modules/apps/management/permission/PermissionViewPage')
  // )

  const ActivityListWrapper = lazy(() =>
    import('../modules/apps/management/activity/ActivityList').then((m) => ({
      default: m.ActivityListWrapper,
    }))
  )

  

  const ActivityViewPage = lazy(() =>
    import('../modules/apps/management/activity/ActivityViewPage').then((m) => ({
      default: m.default,
    }))
  )

  const ServiceProviderDetails = lazy(() =>
    import('../modules/apps/management/directory-list/ServiceProviderDetails').then((m) => ({
      default: m.default,
    }))
  )

  const SkillsListWrapper = lazy(() =>
    import('../modules/apps/management/skills-list/SkillsList').then((m) => ({
      default: m.SkillsListWrapper,
    }))
  )

  const InterestsListWrapper = lazy(() =>
    import('../modules/apps/management/interests-list/InterestsList').then((m) => ({
      default: m.InterestsListWrapper,
    }))
  )

  const QuizListWrapper = lazy(() =>
    import('../modules/apps/management/quiz-list/QuizList').then((m) => ({
      default: m.QuizListWrapper,
    }))
  )

  const NotificationsListWrapper = lazy(() =>
    import('../modules/apps/management/notifications/NotificationsList').then((m) => ({
      default: m.NotificationsListWrapper,
    }))
  )

  const GameListWrapper = lazy(() =>
    import('../modules/apps/management/game-list/GameList').then((m) => ({
      default: m.GameListWrapper,
    }))
  )

  const GameAddPage = lazy(() =>
    import('../modules/apps/management/game-list/GameAddPage').then((m) => ({
      default: m.default,
    }))
  )

  const ReelListWrapper = lazy(() =>
    import('../modules/apps/management/reels-list/ReelList').then((m) => ({
      default: m.ReelListWrapper,
    }))
  )

  const ReportsListWrapper = lazy(() =>
    import('../modules/apps/management/reports-list/ReportsList').then((m) => ({
      default: m.ReportsListWrapper,
    }))
  )

  const DashboardWrapper = lazy(() =>
    import('../pages/dashboard/DashboardWrapper').then((m) => ({
      default: m.DashboardWrapper,
    }))
  )

 

  return (
    <Routes>
      <Route element={<MasterLayout />}>
        <Route path='auth/*' element={<Navigate to='/dashboard' />} />

        <Route
          path='dashboard'
          element={
            <SuspensedView>
              <DashboardWrapper />
            </SuspensedView>
          }
        />

        

        <Route
          path='users'
          element={
            <SuspensedView>
              <PageTitle>User list</PageTitle>
              <UsersListWrapper />
            </SuspensedView>
          }
        />

        <Route
          path='Deleted-Users'
          element={
            <SuspensedView>
              <PageTitle>Deleted Users</PageTitle>
              <DeletedUsersListWrapper />
            </SuspensedView>
          }
        />

        <Route
          path='user-details/:id'
          element={
            <>
              <PageTitle>User Details</PageTitle>
              <UserDetails />
            </>
          }
        />

        <Route
          path='users/add'
          element={
            <>
              <PageTitle>Add User</PageTitle>
              <UserAddPage />
            </>
          }
        />

        <Route
          path='users/edit/:id'
          element={
            <>
              <PageTitle>Edit User</PageTitle>
              <UserAddPage />
            </>
          }
        />

        <Route
          path='events'
          element={
            <SuspensedView>
              <PageTitle>Event List</PageTitle>
              <EventsListWrapper />
            </SuspensedView>
          }
        />

        <Route
          path='event-details/:id'
          element={
            <SuspensedView>
              <PageTitle>Event Details</PageTitle>
              <EventDetails />
            </SuspensedView>
          }
        />

        <Route
          path='events/add'
          element={
            <SuspensedView>
              <PageTitle>Create Event</PageTitle>
              <EventAddPage />
            </SuspensedView>
          }
        />

        <Route
          path='events/edit/:id'
          element={
            <SuspensedView>
              <PageTitle>Edit Event</PageTitle>
              <EventAddPage />
            </SuspensedView>
          }
        />

        <Route
          path='event-categories'
          element={
            <SuspensedView>
              <PageTitle>Event Categories</PageTitle>
              <EventCategoriesListWrapper />
            </SuspensedView>
          }
        />

        <Route
          path='event-categories/add'
          element={
            <SuspensedView>
              <PageTitle>Add Event Category</PageTitle>
              <EventCategoryAddPage />
            </SuspensedView>
          }
        />

        <Route
          path='event-categories/edit/:id'
          element={
            <SuspensedView>
              <PageTitle>Edit Event Category</PageTitle>
              <EventCategoryAddPage />
            </SuspensedView>
          }
        />

        <Route
          path='directory'
          element={
            <SuspensedView>
              <DirectoryListWrapper />
            </SuspensedView>
          }
        />

        <Route
          path='directory/:id'
          element={
            <SuspensedView>
              <PageTitle>Directory Details</PageTitle>
              <ServiceProviderDetails />
            </SuspensedView>
          }
        />

        <Route
          path='roles'
          element={
            <SuspensedView>
              <PageTitle>Role List</PageTitle>
              <RolesListWrapper />
            </SuspensedView>
          }
        />

        <Route
          path='roles/view/:id'
          element={
            <SuspensedView>
              <RoleViewPage />
            </SuspensedView>
          }
        />

        <Route
          path='roles/add'
          element={
            <SuspensedView>
              <PageTitle>Add Role</PageTitle>
              <RoleAddPage />
            </SuspensedView>
          }
        />

        <Route
          path='roles/edit/:id'
          element={
            <SuspensedView>
              <PageTitle>Edit Role</PageTitle>
              <RoleEditPage />
            </SuspensedView>
          }
        />

        <Route
          path='permissions'
          element={
            <SuspensedView>
              <PageTitle>Permission List</PageTitle>
              <PermissionListWrapper />
            </SuspensedView>
          }
        />

        {/* <Route
          path='permissions/view/:id'
          element={
            <SuspensedView>
              <PermissionViewPage />
            </SuspensedView>
          }
        /> */}

        {/* <Route
          path='permissions/add'
          element={
            <SuspensedView>
              <PageTitle>Add Permission</PageTitle>
              <PermissionAddPage />
            </SuspensedView>
          }
        /> */}

        <Route
          path='permissions/edit/:id'
          element={
            <SuspensedView>
              <PageTitle>Edit Permission</PageTitle>
              <PermissionEditPage />
            </SuspensedView>
          }
        />

        <Route
          path='activity'
          element={
            <SuspensedView>
              <PageTitle>Activity List</PageTitle>
              <ActivityListWrapper />
            </SuspensedView>
          }
        />

        <Route
          path='activity/view/:id'
          element={
            <SuspensedView>
              <PageTitle>Activity Details</PageTitle>
              <ActivityViewPage />
            </SuspensedView>
          }
        />

        

        <Route
          path='notifications'
          element={
            <SuspensedView>
              <PageTitle>Notifications</PageTitle>
              <NotificationsListWrapper />
            </SuspensedView>
          }
        />

        <Route
          path='block-users'
          element={
            <SuspensedView>
              <PageTitle>Block User List</PageTitle>
              <BlockListWrapper />
            </SuspensedView>
          }
        />

        <Route
          path='jobs'
          element={
            <SuspensedView>
              <PageTitle>Job List</PageTitle>
              <JobListWrapper />
            </SuspensedView>
          }
        />

        <Route
          path='jobs/add'
          element={
            <>
              <PageTitle>Add Job</PageTitle>
              <JobAddPage />
            </>
          }
        />

        <Route
          path='jobs/edit/:id'
          element={
            <>
              <PageTitle>Edit Job</PageTitle>
              <JobAddPage />
            </>
          }
        />

        <Route
          path='quiz-list'
          element={
            <SuspensedView>
              <PageTitle>Quiz List</PageTitle>
              <QuizListWrapper />
            </SuspensedView>
          }
        />

        <Route
          path='skills'
          element={
            <SuspensedView>
              <PageTitle>Skills</PageTitle>
              <SkillsListWrapper />
            </SuspensedView>
          }
        />

        <Route
          path='interests'
          element={
            <SuspensedView>
              <PageTitle>Interests</PageTitle>
              <InterestsListWrapper />
            </SuspensedView>
          }
        />

        <Route
          path='reels'
          element={
            <SuspensedView>
              <PageTitle>Reels</PageTitle>
              <ReelListWrapper />
            </SuspensedView>
          }
        />

        <Route
          path='reels/add'
          element={
            <SuspensedView>
              <PageTitle>Add Reel</PageTitle>
            </SuspensedView>
          }
        />

        <Route
          path='reports'
          element={
            <SuspensedView>
              <PageTitle>Post Reports</PageTitle>
              <ReportsListWrapper />
            </SuspensedView>
          }
        />

        <Route
          path='game'
          element={
            <SuspensedView>
              <PageTitle>Games</PageTitle>
              <GameListWrapper />
            </SuspensedView>
          }
        />

        <Route
          path='game/add'
          element={
            <SuspensedView>
              <PageTitle>Add Game</PageTitle>
              <GameAddPage />
            </SuspensedView>
          }
        />

        <Route
          path='game/edit/:id'
          element={
            <SuspensedView>
              <PageTitle>Edit Game</PageTitle>
              <GameAddPage />
            </SuspensedView>
          }
        />

        <Route path='*' element={<Navigate to='/dashboard' />} />
      </Route>
    </Routes>
  )
}

const SuspensedView: FC<WithChildren> = ({children}) => {
  const baseColor = getCSSVariableValue('--bs-primary')

  TopBarProgress.config({
    barColors: {'0': baseColor},
    barThickness: 1,
    shadowBlur: 5,
  })

  return <Suspense fallback={<TopBarProgress />}>{children}</Suspense>
}

export {PrivateRoutes}
